const message = 'Wpisz poprawny rocznik'

export default {
    min: {
        value: 1885,
        message,
    },
    max: {
        value: new Date().getFullYear() + 1,
        message,
    }
}